import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const FAQ = () => {
  return <section id="faq" className="py-20 px-6 bg-secondary">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-dark">Häufig gestellte Fragen</h2>
          <p className="text-grey text-lg">
            Hier finden Sie Antworten auf die wichtigsten Fragen zu unserer KI-Wissensplattform.
          </p>
        </div>
        
        <Accordion type="single" collapsible className="w-full space-y-4">
          <AccordionItem value="item-1" className="border border-gray-200 rounded-lg bg-white">
            <AccordionTrigger className="px-6 py-4 hover:no-underline">
              <span className="text-left font-semibold text-lg">Wie funktioniert die Datenanbindung?</span>
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-4 text-grey">
              <p>Unsere offene Lösung  bietet flexible Konnektoren für alle gängigen Datenquellen wie Filesysteme, SharePoint, Datenbanken, CRM/ERP-Systeme und mehr. Die Dokumente werden automatisch aufbereitet, indexiert und in einer Vektordatenbank gespeichert, um optimale Suchergebnisse zu gewährleisten. Der gesamte Prozess läuft auf Ihrer eigenen Infrastruktur, sodass keine Daten Ihr Unternehmen verlassen.</p>
            </AccordionContent>
          </AccordionItem>
          
          <AccordionItem value="item-2" className="border border-gray-200 rounded-lg bg-white">
            <AccordionTrigger className="px-6 py-4 hover:no-underline">
              <span className="text-left font-semibold text-lg">Ist die Datenhoheit gewährleistet?</span>
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-4 text-grey">
              <p>
                Absolut. Die gesamte Lösung wird auf Ihren eigenen Servern, Stackit oder in Azure in Ihrem Account installiert. 
                Alle Daten bleiben zu 100% in Ihrer Umgebung und unter Ihrer vollständigen Kontrolle. Es erfolgt keine 
                Übertragung sensibler Informationen an externe Dienste. Zudem haben Sie umfangreiche 
                Konfigurationsmöglichkeiten für Zugriffsrechte und Datensicherheitsrichtlinien.
              </p>
            </AccordionContent>
          </AccordionItem>
          
          <AccordionItem value="item-3" className="border border-gray-200 rounded-lg bg-white">
            <AccordionTrigger className="px-6 py-4 hover:no-underline">
              <span className="text-left font-semibold text-lg">Welche Vorkenntnisse brauchen Mitarbeiter?</span>
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-4 text-grey">
              <p>
                Die Lösung ist intuitiv bedienbar und erfordert keine speziellen technischen Vorkenntnisse. 
                Mitarbeiter können einfach in natürlicher Sprache mit dem System kommunizieren, ähnlich wie 
                bei ChatGPT, aber mit Zugriff auf Ihr internes Unternehmenswissen. Wir bieten eine 2 stündige
                Einführung, um die wichtigsten Funktionen kennenzulernen und effektiv zu nutzen.
              </p>
            </AccordionContent>
          </AccordionItem>
          
          <AccordionItem value="item-4" className="border border-gray-200 rounded-lg bg-white">
            <AccordionTrigger className="px-6 py-4 hover:no-underline">
              <span className="text-left font-semibold text-lg">Wie hoch ist der Implementierungsaufwand?</span>
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-4 text-grey">
              <p>
                Die Grundinstallation der KI-Wissensplattform kann innerhalb von 1 Woche erfolgen. 
                Der Gesamtaufwand hängt primär vom Umfang der anzubindenden Datenquellen ab. 
                Für eine typische mittelständische Implementierung rechnen wir mit einem Projekt 
                von 3-4 Wochen bis zur vollständigen Produktivstellung. Unser Experten-Team begleitet 
                Sie während des gesamten Prozesses und stellt sicher, dass die Lösung optimal auf 
                Ihre Bedürfnisse abgestimmt ist.
              </p>
            </AccordionContent>
          </AccordionItem>
          
          <AccordionItem value="item-5" className="border border-gray-200 rounded-lg bg-white">
            <AccordionTrigger className="px-6 py-4 hover:no-underline">
              <span className="text-left font-semibold text-lg">Welche Hardware-Anforderungen gibt es?</span>
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-4 text-grey">
              <p>
                Die Hardware-Anforderungen variieren je nach erwartetem Nutzungsvolumen und 
                eingesetztem KI-Modell. Für mittelständische Unternehmen empfehlen wir eine 
                Azure-Umgebung mit GPU-Unterstützung, Stackit Cloud oder dedizierte Server mit entsprechender 
                Ausstattung. Wir beraten Sie gerne individuell bei der Dimensionierung und können 
                verschiedene Szenarien für unterschiedliche Leistungsklassen durchrechnen.
              </p>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </section>;
};
export default FAQ;